(function () {
  var MAX_BADGES = 3;
  var BUILTIN_ORDER = { soldout: 0, sale: 1, new: 2, preorder: 3 };
  var configByHandle = {};

  function loadConfig() {
    var el = document.querySelector('[data-badge-manager-config]');
    if (!el) return;
    var list;
    try {
      list = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    list.forEach(function (item) {
      if (item.handle) configByHandle[item.handle] = item;
    });
  }

  function handleFromSpan(span) {
    var match = null;
    span.classList.forEach(function (cls) {
      if (cls.indexOf('t4s-badge-') === 0 && cls !== 't4s-badge-item' && cls !== 't4s-badge-custom') {
        match = cls.replace('t4s-badge-', '');
      }
    });
    return match;
  }

  function builtinKey(span) {
    for (var key in BUILTIN_ORDER) {
      if (span.classList.contains('t4s-badge-' + key)) return key;
    }
    return null;
  }

  function isVisible(span) {
    if (span.hasAttribute('hidden')) return false;
    var cs = window.getComputedStyle(span);
    return cs.display !== 'none';
  }

  var TEXTURE_CLASSES = ['t4s-badge-texture-diagonal', 't4s-badge-texture-dots', 't4s-badge-texture-grain', 't4s-badge-texture-linen'];
  var TEXTURE_STYLE_CLASS = {
    diagonal: 't4s-badge-texture-diagonal',
    dots: 't4s-badge-texture-dots',
    grain: 't4s-badge-texture-grain',
    linen: 't4s-badge-texture-linen'
  };

  function styleCustomBadge(span, cfg) {
    if (!cfg) return;
    span.style.backgroundColor = cfg.color;
    span.style.color = cfg.textColor;
    if (cfg.shape === '1' || cfg.shape === '2') {
      span.style.clipPath = 'none';
      span.style.borderRadius = cfg.shape === '1' ? '30px' : '0';
      span.style.padding = '5px 10px';
      span.style.backgroundImage = 'none';
      // The default ribbon shape (shape "3" / "use global" when global is
      // ribbon) has a folded-paper shadow pseudo-element that's specific to
      // its diagonal cut - suppress it once a badge opts into a different,
      // non-ribbon shape so it doesn't leave a stray shadow behind.
      span.classList.add('t4s-badge-shape-override');
    } else if (cfg.shape === '3') {
      span.style.clipPath = 'polygon(0 0, 100% 0, 80% 100%, 0 100%)';
      span.style.borderRadius = '0';
      span.style.paddingRight = '22px';
      span.classList.remove('t4s-badge-shape-override');
    } else {
      span.classList.remove('t4s-badge-shape-override');
    }
    span.classList.remove.apply(span.classList, TEXTURE_CLASSES);
    if (cfg.texture) {
      span.style.backgroundImage = 'linear-gradient(rgba(255,255,255,.12), rgba(255,255,255,.12)), url(' + cfg.texture + ')';
      span.style.backgroundSize = 'cover';
      span.style.backgroundBlendMode = 'overlay';
    } else if (cfg.textureStyle && TEXTURE_STYLE_CLASS[cfg.textureStyle]) {
      span.classList.add(TEXTURE_STYLE_CLASS[cfg.textureStyle]);
    }
    if (cfg.icon && !span.querySelector('[data-badge-icon]')) {
      var img = document.createElement('img');
      img.src = cfg.icon;
      img.alt = '';
      img.setAttribute('data-badge-icon', '');
      img.style.cssText = 'width:12px;height:12px;margin-right:5px;flex:0 0 auto;object-fit:contain;';
      span.insertBefore(img, span.firstChild);
    }
  }

  function processContainer(container) {
    var spans = Array.prototype.filter.call(container.children, function (el) {
      return el.tagName === 'SPAN' && isVisible(el);
    });
    if (!spans.length) return;

    var ranked = spans.map(function (span, i) {
      var bKey = builtinKey(span);
      var sortKey;
      if (bKey) {
        sortKey = BUILTIN_ORDER[bKey];
      } else {
        var handle = handleFromSpan(span);
        var cfg = handle ? configByHandle[handle] : null;
        if (cfg) {
          styleCustomBadge(span, cfg);
          sortKey = 10 + cfg.priority;
        } else {
          sortKey = 1000 + i;
        }
      }
      return { span: span, sortKey: sortKey };
    });

    ranked.sort(function (a, b) { return a.sortKey - b.sortKey; });

    ranked.forEach(function (entry, index) {
      entry.span.style.order = index;
      entry.span.style.display = index < MAX_BADGES ? '' : 'none';
    });
  }

  function processAll() {
    document.querySelectorAll('.t4s-product-badge, .t4s-single-product-badge').forEach(processContainer);
  }

  function init() {
    loadConfig();
    processAll();

    var observer = new MutationObserver(function (mutations) {
      var containers = new Set();
      mutations.forEach(function (m) {
        var target = m.target.closest ? m.target.closest('.t4s-product-badge, .t4s-single-product-badge') : null;
        if (target) containers.add(target);
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('.t4s-product-badge, .t4s-single-product-badge')) {
            containers.add(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('.t4s-product-badge, .t4s-single-product-badge').forEach(function (c) {
              containers.add(c);
            });
          }
        });
      });
      containers.forEach(processContainer);
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', processAll);
})();
